import React, { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useFetch } from '../../../../../shared/hooks';
import apiRoutes from '../../../../../../config/api/routes';
import { Block } from '../../../../../../config/api/models/Block';
import { getStudentVideoProgressMapper } from '../../../../../../config/api/models';
import { useAppSelector } from 'src/modules/shared/hooks/useAppDispatch';
import { AnswersLabel, Col, Label, Row, VideoProgressWrapper } from './Atoms';

type Props = {
  block: Block;
};

const VideoStudentProgress: FC<Props> = ({ block }) => {
  const { t } = useTranslation();
  const selectedStudent = useAppSelector((state) => state.filters.selectedStudent);
  const refresh = useAppSelector((state) => state.filters.refresh);

  const [getStudentVideoProgressResponse, getStudentVideoProgress] = useFetch('', {
    mapper: getStudentVideoProgressMapper,
  });

  useEffect(() => {
    if (selectedStudent === '') return;
    if (block.content == null) return;
    getStudentVideoProgress({
      path: apiRoutes.studentVideoProgress(selectedStudent || '', block.id),
    });
  }, [getStudentVideoProgress, block.content, refresh, selectedStudent, block.id]);

  return getStudentVideoProgressResponse.success ? (
    <VideoProgressWrapper>
      <>
        {getStudentVideoProgressResponse.data.played === undefined ? (
          <>{t('trajectory.sections.shared.video.noResults')}</>
        ) : (
          <Row>
            <AnswersLabel>{t('trajectory.sections.shared.video.myStats')}</AnswersLabel>
            <Col>
              <Label>{t('trajectory.sections.shared.video.lastStarted')}: </Label>
              {getStudentVideoProgressResponse.data.lastWatched}
            </Col>
            <Col>
              <Label>{t('trajectory.sections.shared.video.progress')}: </Label>
              {Math.round(getStudentVideoProgressResponse.data.played * 100) + '%'}
            </Col>
          </Row>
        )}
      </>
    </VideoProgressWrapper>
  ) : null;
};

export default VideoStudentProgress;
